import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Clock, Calendar, Target, Users } from 'lucide-react';
import { Seo } from '../components/Seo';
import { BUSINESS, SEASON } from '../data/site';
import { GROUP_PROGRAMS } from '../data/programs';
export function Fall2026() {
  return <div className="w-full" data-id="element-486" data-mp="2ukwj6m9o2o1w">
      <Seo title="Fall 2026 Training Schedule | Reach Performance McKinney" description="Reach Performance fall 2026 runs September 1 to December 17 in McKinney, TX. High school sessions Tuesday and Thursday 5:45 to 7:00 PM plus homeschool daytime blocks." path="/fall-2026" data-id="element-487" data-mp="2uk3edqu9q8me" />
      <Hero data-id="element-488" data-mp="26usesconmk9u" />
      <LocationBanner data-id="element-489" data-mp="26u95fkd2l47f" />
      <IntroSection data-id="element-490" data-mp="26tqztx4ipdmu" />
      <ProgramsAndSchedule data-id="element-491" data-mp="2bmtxagcf178b" />
      <WeekAtAGlance data-id="element-492" data-mp="2bn2ayagd4gkk" />
      <OneGroupEverySport data-id="element-493" data-mp="2bnlj4zg7nqle" />
      <TestingAndCalendar data-id="element-494" data-mp="1e6wk1dinb2fp" />
      <MembershipIncludes data-id="element-495" data-mp="1e7ogeqk2h471" />
      <FinalCta data-id="element-496" data-mp="1e6dcmqqmfwfx" />
    </div>;
}

/* ---------- HERO ---------- */
function Hero() {
  return <section className="relative bg-reach-black overflow-hidden py-20 md:py-28" data-id="element-497" data-mp="1j4oiyrhpjote">
      <div className="absolute inset-0 z-0" data-id="element-498" data-mp="3gc7x7qld4f3a">
        <img src="https://images.unsplash.com/photo-1517649763962-0c623066013b?q=70&w=1600&auto=format&fit=crop" alt="Athletes training on indoor turf" decoding="async" className="w-full h-full object-cover grayscale contrast-125 opacity-60" data-id="element-499" data-mp="3gfdqli10y34t" />
        <div className="absolute inset-0 bg-black/75" data-id="element-500" data-mp="32js2re6j1pdz" />
        <div className="absolute inset-0 bg-reach-red mix-blend-multiply opacity-[0.08]" data-id="element-501" data-mp="2xn1kck792hpe" />
      </div>

      <div className="absolute inset-0 z-10 pointer-events-none overflow-hidden" data-id="element-502" data-mp="2smncp39k99rw">
        <div className="absolute top-1/3 -left-40 w-[55%] h-2 bg-reach-red transform -rotate-[7deg] opacity-50" data-id="element-503" data-mp="2ollcok7tktov" />
        <div className="absolute top-[44%] -left-40 w-[40%] h-2 bg-reach-red transform -rotate-[7deg] opacity-30" data-id="element-504" data-mp="2jo1z7miy4kxz" />
        <div className="absolute top-[55%] -left-40 w-[28%] h-2 bg-reach-red transform -rotate-[7deg] opacity-20" data-id="element-505" data-mp="mtf79bxhksj4" />
      </div>

      <div className="relative z-20 max-w-container mx-auto px-4 md:px-8 text-center" data-id="element-506" data-mp="htkhjbpg68zn">
        <p className="font-inter text-reach-red-light text-xs md:text-sm uppercase tracking-[0.3em] font-semibold mb-5" data-id="element-507" data-mp="10yz5ayghkhrb">
          Fall Season · {SEASON.range}
        </p>
        <h1 className="font-bebas text-white text-[56px] sm:text-7xl md:text-8xl lg:text-[108px] leading-[0.9] tracking-wide mb-5" data-id="element-508" data-mp="s0n8gep10nqf">
          Fall Training Schedule
        </h1>
        <p className="font-inter text-white text-base md:text-xl max-w-2xl mx-auto leading-relaxed" data-id="element-509" data-mp="1knpxmg7tbm40">
          The school year is where the work pays off. High school athletes train Tuesday and
          Thursday evenings. Homeschool athletes train in daytime blocks.
        </p>
      </div>
    </section>;
}

/* ---------- LOCATION BANNER ---------- */
function LocationBanner() {
  return <section className="bg-reach-red" data-id="element-510" data-mp="3vfrk29yduchp">
      <div className="max-w-container mx-auto px-4 md:px-8 py-4 md:py-5" data-id="element-511" data-mp="3vepw54w9pvik">
        <p className="font-inter text-white text-center text-xs md:text-sm uppercase tracking-[0.25em] font-semibold" data-id="element-512" data-mp="4b16xkl6lwf9">
          Inside {BUSINESS.venue} · {BUSINESS.street} · {BUSINESS.city} {BUSINESS.state}{' '}
          {BUSINESS.zip}
        </p>
      </div>
    </section>;
}

/* ---------- INTRO SECTION ---------- */
function IntroSection() {
  return <section className="bg-white py-16 md:py-20" data-id="element-513" data-mp="s2eu05x4akd">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center" data-id="element-514" data-mp="tdi7yvgbgay">
        <p className="font-inter text-reach-black text-lg md:text-xl leading-relaxed" data-id="element-515" data-mp="397dpcqnsbtgb">
          The fall season starts {SEASON.startLong} and ends {SEASON.endLong}. High school athletes
          from every sport train together in one capped group. In-season athletes train around their
          match schedule, not through it.
        </p>
      </div>
    </section>;
}

/* ---------- PROGRAMS AND SCHEDULE ---------- */
function ProgramsAndSchedule() {
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-516" data-mp="2qf1dndb8rfti">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-517" data-mp="2lh9pmudpwdul">
        <div className="text-center mb-14" data-id="element-518" data-mp="2z5a0c7ur9d81">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-519" data-mp="2z6cnq5svcxj7">
            Programs and Class Times
          </p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-wide" data-id="element-520" data-mp="393hdeflxbb4r">Choose Your Group</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-521" data-mp="3dufxlqa18tda">
          {GROUP_PROGRAMS.map(program => <article key={program.id} className="relative bg-white rounded-[4px] p-7 md:p-8 border-b-4 border-transparent hover:border-reach-red transition-colors duration-200 flex flex-col" data-id="element-522" data-mp="3huzt6peyjoxb">
              <p className="font-inter text-reach-red text-xs uppercase tracking-[0.25em] font-semibold mb-3" data-id="element-523" data-mp="3rrunsx84156b">
                {program.eyebrow}
              </p>
              <h3 className="font-bebas text-3xl md:text-4xl tracking-wide leading-none mb-4" data-id="element-524" data-mp="1xh8xewbqasyo">
                {program.title}
              </h3>
              <div className="flex flex-wrap items-center gap-x-5 gap-y-2 mb-5 text-sm font-inter text-reach-black/70" data-id="element-525" data-mp="jjmu38dr82m6">
                <span className="flex items-center gap-2" data-id="element-526" data-mp="eso8pudwsec2">
                  <Clock size={14} className="text-reach-red" aria-hidden="true" data-id="element-527" data-mp="er3ey6zf4zf9" />
                  <span className="uppercase tracking-wider" data-id="element-528" data-mp="arksv7vv2iau">{program.duration}</span>
                </span>
                <span className="flex items-center gap-2" data-id="element-529" data-mp="5q59rld8ulv3">
                  <Users size={14} className="text-reach-red" aria-hidden="true" data-id="element-530" data-mp="12hh9q59e1cdj" />
                  <span className="uppercase tracking-wider" data-id="element-531" data-mp="ygnl19o4ftjl">{program.cap}</span>
                </span>
              </div>
              <div className="border-t border-black/10 pt-4" data-id="element-532" data-mp="tgj27czqqmq7">
                <h4 className="font-inter text-xs uppercase tracking-[0.25em] text-reach-black/60 mb-3" data-id="element-533" data-mp="oizms9rb43wo">
                  Weekly Schedule
                </h4>
                <ul className="space-y-2 mb-4" data-id="element-534" data-mp="3e9cp4yh15oeu">
                  {program.slots.map(slot => <li key={`${slot.days}-${slot.time}`} className="font-inter text-sm text-reach-black" data-id="element-535" data-mp="397nhlst0nsvi">
                      <span className="font-semibold" data-id="element-536" data-mp="3fnxe0lpumtfl">{slot.days}</span> · {slot.time}
                    </li>)}
                </ul>
                <p className="font-inter text-sm text-reach-black/75 leading-relaxed" data-id="element-537" data-mp="36oilzhu1aasz">
                  {program.body}
                </p>
              </div>
              <div className="mt-auto pt-5" data-id="element-538" data-mp="2ry32q8l6hcxg">
                <p className="font-bebas text-2xl tracking-wide text-reach-black" data-id="element-539" data-mp="2wq2vnh2tz5kj">
                  {program.priceLabel}
                </p>
                {program.priceOptions && <ul className="mt-2 space-y-1" data-id="element-540" data-mp="2ix4xjmz06zda">
                    {program.priceOptions.map(option => <li key={option} className="font-inter text-sm text-reach-black/80" data-id="element-541" data-mp="2911umewbuwpa">
                        {option}
                      </li>)}
                  </ul>}
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}

/* ---------- WEEK AT A GLANCE ---------- */
function WeekAtAGlance() {
  const schedule = [{
    time: '10:00 AM start',
    mon: 'HOMESCHOOL MULTISPORT',
    tue: '',
    wed: '',
    thu: ''
  }, {
    time: '12:00 PM start',
    mon: '',
    tue: '',
    wed: 'HOMESCHOOL MULTISPORT',
    thu: ''
  }, {
    time: '2:30 to 4:00 PM',
    mon: '',
    tue: 'HOMESCHOOL MULTISPORT',
    wed: '',
    thu: 'HOMESCHOOL MULTISPORT'
  }, {
    time: '5:45 to 7:00 PM',
    mon: '',
    tue: 'ADVANCED PERFORMANCE 14+',
    wed: '',
    thu: 'ADVANCED PERFORMANCE 14+'
  }];
  return <section className="bg-white py-20 md:py-28" data-id="element-542" data-mp="2i4fjai2vd5c8">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-543" data-mp="2w2x1y1dx3rna">
        <div className="text-center mb-12" data-id="element-544" data-mp="2w12i6qedu5ks">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-545" data-mp="2s2mrabf6kd23">
            The Week at a Glance
          </p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-wide" data-id="element-546" data-mp="2drj1j5m4czz">Full Schedule</h2>
        </div>

        <div className="overflow-x-auto max-w-4xl mx-auto" data-id="element-547" data-mp="7cb8htjf06x3">
          <table className="w-full min-w-[620px] border-collapse" data-id="element-548" data-mp="caw57izgk8gs">
            <caption className="sr-only" data-id="element-549" data-mp="gbofmfk2gjen">
              Reach Performance fall 2026 weekly class times by day
            </caption>
            <thead data-id="element-550" data-mp="3frux2f95515t">
              <tr className="bg-reach-black text-white" data-id="element-551" data-mp="3fo72rdvvgaq1">
                <th scope="col" className="font-bebas text-lg tracking-wider uppercase text-left p-4 border-r border-white/10" data-id="element-552" data-mp="3kqfyuj41jswd">
                  Time
                </th>
                <th scope="col" className="font-bebas text-lg tracking-wider uppercase p-4 border-r border-white/10" data-id="element-553" data-mp="3thg9f6sfqi4v">
                  Monday
                </th>
                <th scope="col" className="font-bebas text-lg tracking-wider uppercase p-4 border-r border-white/10" data-id="element-554" data-mp="2wxpo2d7vjfno">
                  Tuesday
                </th>
                <th scope="col" className="font-bebas text-lg tracking-wider uppercase p-4 border-r border-white/10" data-id="element-555" data-mp="2tgtk17a7dcuv">
                  Wednesday
                </th>
                <th scope="col" className="font-bebas text-lg tracking-wider uppercase p-4" data-id="element-556" data-mp="2kgy46p5pctoi">
                  Thursday
                </th>
              </tr>
            </thead>
            <tbody data-id="element-557" data-mp="2fkg07ri74zd8">
              {schedule.map((row, i) => <tr key={row.time} className={i % 2 === 0 ? 'bg-reach-gray' : 'bg-white'} data-id="element-558" data-mp="2ajs9l6xvqkjj" data-mpi={i}>
                  <th scope="row" className="font-inter text-sm font-semibold text-reach-black text-left p-4 border-r border-black/5 normal-case tracking-normal" data-id="element-559" data-mp="25riezdltkwax">
                    {row.time}
                  </th>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4 border-r border-black/5" data-id="element-560" data-mp="1rt2bdvj97lx0">
                    {row.mon}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4 border-r border-black/5" data-id="element-561" data-mp="2k4ksjpwox1nj">
                    {row.tue}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4 border-r border-black/5" data-id="element-562" data-mp="2tumh0isygm2z">
                    {row.wed}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4" data-id="element-563" data-mp="2168fvu6kl9n7">
                    {row.thu}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="font-inter text-center text-sm text-reach-black/70 mt-8 max-w-2xl mx-auto" data-id="element-564" data-mp="2b5zf2962sctm">
          Monday and Wednesday homeschool blocks are listed as start times. Text or call to confirm
          the block that fits your week.
        </p>
      </div>
    </section>;
}

/* ---------- ONE GROUP, EVERY SPORT ---------- */
function OneGroupEverySport() {
  const points = ['Acceleration, top speed, and change of direction', 'Jump and landing mechanics under coaching', 'Strength progressed by tier, earned not assigned', 'In-season load management around competition'];
  return <section className="bg-reach-black text-white py-20 md:py-28 relative overflow-hidden" data-id="element-565" data-mp="udvjfvxnkx86">
      <div className="absolute -right-40 top-1/4 w-[50%] h-1 bg-reach-red opacity-30 rotate-[6deg]" data-id="element-566" data-mp="zbdwnyipdylz" />
      <div className="absolute -right-40 top-[34%] w-[35%] h-1 bg-reach-red opacity-20 rotate-[6deg]" data-id="element-567" data-mp="1n1hxxz8f5m9t" />

      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-568" data-mp="1r4eb3af6wq6d">
        <div className="text-center mb-12" data-id="element-569" data-mp="1d9u2zocnln3l">
          <p className="font-inter text-reach-red-light text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-570" data-mp="1d8sn96kp0cfj">
            Advanced Performance
          </p>
          <h2 className="font-bebas text-5xl md:text-6xl tracking-wide leading-none mb-4" data-id="element-571" data-mp="25yj3pm9srqet">
            One Group.
            <br data-id="element-572" data-mp="2aru1yz0jmyv4" />
            Every Sport.
          </h2>
          <p className="font-inter text-white text-lg md:text-xl max-w-2xl mx-auto" data-id="element-573" data-mp="2kmszbi60hul6">
            High school athletes train together Tuesday and Thursday from 5:45 to 7:00 PM, capped at
            10 so every athlete gets coached.
          </p>
        </div>

        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto" data-id="element-574" data-mp="2aq6dor5v2zi3">
          {points.map(item => <li key={item} className="flex items-start gap-3 border border-white/10 bg-white/[0.04] rounded-[4px] p-5" data-id="element-575" data-mp="21nez4ihovnm8">
              <Check size={16} className="text-reach-red-light shrink-0 mt-1" aria-hidden="true" data-id="element-576" data-mp="1wv433qq2klyy" />
              <span className="font-inter text-sm text-white" data-id="element-577" data-mp="1ry3rz1ed4t0z">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}

/* ---------- TESTING AND CALENDAR ---------- */
function TestingAndCalendar() {
  return <section className="bg-white py-20 md:py-28" data-id="element-578" data-mp="1dxt13yd1zeft">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-579" data-mp="1dz44hx2l6k6e">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-580" data-mp="3plpj3q259wfq">
          <div className="bg-reach-gray rounded-[4px] p-8 md:p-10 border-l-4 border-reach-red" data-id="element-581" data-mp="3pnipd48uien7">
            <h2 className="flex items-center gap-3 mb-4 font-bebas text-2xl md:text-3xl tracking-wide uppercase leading-none" data-id="element-582" data-mp="3tom8q0q3qst6">
              <Target size={24} className="text-reach-red" aria-hidden="true" data-id="element-583" data-mp="7g33vasrs0bu" />
              Testing Every 4 Weeks
            </h2>
            <p className="font-inter text-reach-black text-base leading-relaxed mb-6" data-id="element-584" data-mp="35yi1ljdpgaxf">
              Athletes are tested in the first week of the season and then every 4 weeks through
              December 17. The same markers each time, so progress is measured rather than guessed
              at.
            </p>
            <ul className="space-y-3" data-id="element-585" data-mp="3kneatjrhztzm">
              {['Force plate testing for jump and landing output', 'Speed gate testing for 10 yard and flying 10', '5-10-5 shuttle, vertical jump, and broad jump'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-586" data-mp="xq3hjr6eoz8f">
                  <Check size={16} className="text-reach-red shrink-0 mt-1" strokeWidth={3} aria-hidden="true" data-id="element-587" data-mp="torotcs8jxw0" />
                  <span className="font-inter text-base text-reach-black leading-relaxed" data-id="element-588" data-mp="12nltlqfpzukn">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-reach-gray rounded-[4px] p-8 md:p-10 border-l-4 border-reach-red" data-id="element-589" data-mp="1cdolfnb3v2he">
            <h2 className="flex items-center gap-3 mb-4 font-bebas text-2xl md:text-3xl tracking-wide uppercase leading-none" data-id="element-590" data-mp="1qcy1mmzb9wld">
              <Calendar size={24} className="text-reach-red" aria-hidden="true" data-id="element-591" data-mp="1ld1uwfz8br24" />
              Fall Calendar
            </h2>
            <ul className="space-y-4" data-id="element-592" data-mp="3n6j43o30czyz">
              {[`Season starts ${SEASON.startLong}, right as McKinney, Frisco, and Allen head back to school.`, 'No sessions Thanksgiving week, November 24 and 26.', `Season ends ${SEASON.endLong}, before winter break.`, 'Aligned with the McKinney, Frisco, and Allen ISD calendars.'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-593" data-mp="1xwyvovzvm8lx">
                  <Check size={16} className="text-reach-red shrink-0 mt-1" strokeWidth={3} aria-hidden="true" data-id="element-594" data-mp="1jxz53isszjn4" />
                  <span className="font-inter text-base text-reach-black leading-relaxed" data-id="element-595" data-mp="1axkk6kjr46k5">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}

/* ---------- MEMBERSHIP INCLUDES ---------- */
const INCLUDES = ['Access to the on-site recovery zone after every session.', 'Free athlete evaluation before the first session.', 'Force plate and speed gate testing every 4 weeks.', 'Periodized programming, never random workouts.', 'Small groups capped at 10 for individualized coaching.', 'Integrated speed and strength every session.'];
function MembershipIncludes() {
  return <section className="bg-reach-gray py-20 md:py-24" data-id="element-596" data-mp="84yj73bb2yfz">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-597" data-mp="86jdqsxmehdu">
        <div className="text-center mb-10" data-id="element-598" data-mp="14v7hck8la23q">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-599" data-mp="14u6366wa0zhs">
            Every Membership Includes
          </p>
          <h2 className="font-bebas text-4xl md:text-5xl tracking-wide leading-none" data-id="element-600" data-mp="w1uf2romxo4z">
            What's Included
          </h2>
        </div>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-white rounded-[4px] p-6 md:p-8 border-l-4 border-reach-red" data-id="element-601" data-mp="r3avuz1feqgb">
          {INCLUDES.map(item => <li key={item} className="flex items-start gap-3" data-id="element-602" data-mp="1jr6yslhl9elj">
              <div className="w-6 h-6 bg-reach-red rounded-sm flex items-center justify-center shrink-0 mt-0.5" data-id="element-603" data-mp="1r3czkcqz7hug">
                <Check size={14} className="text-white" strokeWidth={3} aria-hidden="true" data-id="element-604" data-mp="1w1xwo3axlleo" />
              </div>
              <span className="font-inter text-reach-black text-base" data-id="element-605" data-mp="211atngvio8uz">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}

/* ---------- FINAL CTA ---------- */
function FinalCta() {
  return <section className="bg-reach-red py-16 md:py-20" data-id="element-606" data-mp="2a1pigq7ow638">
      <div className="max-w-container mx-auto px-4 md:px-8 text-center" data-id="element-607" data-mp="2f121t0zcqv12">
        <h2 className="font-bebas text-white text-5xl md:text-7xl tracking-wide mb-4" data-id="element-608" data-mp="2eyz4dvvvdzmb">
          Reserve Your Fall Spot
        </h2>
        <p className="font-inter text-white text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-609" data-mp="2ormz8l3ahtie">
          Groups are capped at 10 athletes. When a slot fills, it fills.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center max-w-md sm:max-w-none mx-auto" data-id="element-610" data-mp="2xrtas1ffgjex">
          <Link to="/book" className="inline-flex items-center justify-center bg-white text-reach-black font-inter font-semibold px-6 min-h-[44px] md:min-h-[48px] rounded-[4px] transition-all duration-200 ease-out hover:bg-reach-black hover:text-white uppercase tracking-wide text-sm md:text-base hover:-translate-y-[3px]" data-id="element-611" data-mp="3j1ysbc5tfcjw">
            Book Free Athlete Evaluation
          </Link>
          <Link to="/pricing" className="btn-secondary-dark sm:w-auto" data-id="element-612" data-mp="30d215h5pt05w">
            View Training Rates
          </Link>
        </div>
      </div>
    </section>;
}